export default {"src":"/_next/static/media/God-badge.34ca0bc1.svg","height":46,"width":46};